// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"fc6248a0","257":"ef167f0f","632":"a52ad5e5","850":"10bc5aef"}[chunkId] + ".chunk.js";
};